import React, { useState, useEffect, useRef, useCallback } from 'react';
import '../styling/HeroCarousel.css';

import welcome from '../images/welcome.jpg'; // Replace with actual images for better results

const heroSlidesData = [
  {
    title: "WELCOME TO THE OFFICIAL WEBSITE OF VOETA",
    description:
      "We offer top-tier services across multiple sectors, including Travel, Security, Cleaning, Real Estate, and Construction.",
    background: welcome,
    link: "#",
  },
  {
    title: "Travel Agency",
    description:
      "Our Travel Agency handles vacation planning, business trips, study-abroad, and visa support.",
    background: welcome,
    link: "/travel",
  },
  {
    title: "Security Agency",
    description:
      "We provide professional, reliable protection services for people, property, and assets.",
    background: welcome,
    link: "/security",
  },
  {
    title: "Cleaning Agency",
    description:
      "Reliable and professional cleaning services for residential and commercial spaces.",
    background: welcome,
    link: "/cleaning",
  },
  {
    title: "Real Estate Agency",
    description:
      "Find your next home, investment, or have your property managed with peace of mind.",
    background: welcome,
    link: "/realestate",
  },
  {
    title: "Construction",
    description:
      "We build your vision from concept to completion with quality craftsmanship.",
    background: welcome,
    link: "/construction",
  },

];

function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const length = heroSlidesData.length;
  const intervalRef = useRef(null);

  const stopAutoSlide = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  const startAutoSlide = useCallback(() => {
    stopAutoSlide();
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % length);
    }, 6000);
  }, [length, stopAutoSlide]);

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % length);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + length) % length);
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, [startAutoSlide, stopAutoSlide]);

  return (
    <section
      className="hero"
      onMouseEnter={stopAutoSlide}
      onMouseLeave={startAutoSlide}
    >
      {heroSlidesData.map((slide, index) => (
        <a
          href={slide.link}
          key={index}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          style={{
            backgroundImage: `url(${slide.background})`,
          }}
        >
          <div className="overlay" />
          <div className="hero-content">
            <h1>{slide.title}</h1>
            <p>{slide.description}</p>
          </div>
        </a>
      ))}

      <button className="nav prev" onClick={goToPrev} aria-label="Previous Slide">
        &#10094;
      </button>
      <button className="nav next" onClick={goToNext} aria-label="Next Slide">
        &#10095;
      </button>

      <div className="carousel-indicators">
        {heroSlidesData.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(idx)}
          ></span>
        ))}
      </div>
    </section>
  );
}

export default HeroCarousel;
